import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MessengerFlags} from './messenger-flags';
import {MessengerPortBacklog, routedPort} from './messenger-port';
import {MemberStatus, MessengerMemberRef} from './messenger.models';
import {MessengerPresenceReal} from './presence.real';
import {MessengerPresenceFixture} from './presence.fixture';

/** THE PRESENCE PORT (ITP-E-194-02): who is around, on every face. Records are keyed by lower-case email. */
@Injectable({
  providedIn: 'root',
  useFactory: () => routedPort<MessengerPresencePort>(inject(MessengerPresenceReal), inject(MessengerPresenceFixture),
    MESSENGER_PRESENCE_BACKLOG, inject(MessengerFlags))
})
export abstract class MessengerPresencePort {
  /** B-15: per-member `status { availability, statusMessage }`, answering again on `UserStatusUpdatedEvent`. */
  abstract statuses(members: MessengerMemberRef[]): Observable<Record<string, MemberStatus>>;

  /** B-15: how many members of a conversation are online. */
  abstract onlineCount(conversationId: string, members: MessengerMemberRef[]): Observable<number>;
}

export const MESSENGER_PRESENCE_BACKLOG: MessengerPortBacklog<MessengerPresencePort> = {
  statuses: 'B-15',
  onlineCount: 'B-15'
};
